import { IPracticeAnswerResult, IPracticeAnswerSubmission } from "../IUnitResultModel";

export const practiceAnswerResultToPassDTO  = ({ task, correctOption }: IPracticeAnswerResult): IPracticeAnswerSubmission => ({
  task,
  correctOption,
})

export const practiceAnswerResultToPassDTOList = (list) => list.map(practiceAnswerResultToPassDTO );